import { useFormik } from 'formik';
import React from 'react';
import { useAppDispatch } from '../../../../store/hooks';
import { addAttendanceAdjustment } from '../../../../store/HR/Person/AttendanceAdjustmentSlice';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const AddAttendanceAdjustment = ({ personId }: { personId: string }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: {
      personId: personId,
      startDateTime: '',
      endDateTime: '',
      attendenceAdjustmentType: '',
      reason: '',
      isAme: false,
      status: 0,
    },

    // validationSchema: formAbsenseSchema(t),

    onSubmit: async (values) => {
      try {
        const response = await dispatch(
          addAttendanceAdjustment({
            personId: personId,
            startDateTime: values.startDateTime,
            endDateTime: values.endDateTime,
            attendenceAdjustmentType: values.attendenceAdjustmentType,
            reason: values.reason,
            isAme: false,
            // status: 0,
          })
        );
        debugger
        if (response?.payload?.succeeded === true) {
        } else {
          CustomAlert({ action: 'Error', msg: response?.payload?.message });
          formik.resetForm();
        }
      } catch (error) {
        console.log(error);
        formik.setSubmitting(false);
        CustomAlert({ action: 'Error' });
      }
    },
  });

  return (
    <>
      <Form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-xl-4">
            <div className="form-group mb-3">
              <label className="form-label">{t('startDateTime')}</label>
              <Form.Control
                className="form-control"
                // type="text"
                type="datetime-local"
                autoComplete="off"
                name="startDateTime"
                onChange={formik.handleChange}
                value={formik.values.startDateTime}
                isInvalid={!!formik.errors.startDateTime}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.startDateTime}
              </Form.Control.Feedback>
            </div>
          </div>
          <div className="col-xl-4">
            <div className="form-group mb-3">
              <label className="form-label">{t('endDateTime')}</label>
              <Form.Control
                className="form-control"
                // type="text"
                type="datetime-local"
                autoComplete="off"
                name="endDateTime"
                onChange={formik.handleChange}
                value={formik.values.endDateTime}
                isInvalid={!!formik.errors.endDateTime}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.endDateTime}
              </Form.Control.Feedback>
            </div>
          </div>
          <div className="col-xl-4">
            <div className="form-group mb-3">
              <label className="form-label">{t('attendenceAdjustmentType')}</label>
              <Form.Control
                className="form-control"
                type="text"
                autoComplete="off"
                name="attendenceAdjustmentType"
                onChange={formik.handleChange}
                value={formik.values.attendenceAdjustmentType}
                isInvalid={!!formik.errors.attendenceAdjustmentType}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.attendenceAdjustmentType}
              </Form.Control.Feedback>
            </div>
          </div>
        </div>
        <div className="col-xl-12">
          <div className="form-group mb-3">
            <label className="form-label">{t('reason')}</label>
            <Form.Control
              className="form-control"
              as="textarea"
              rows={3}
              name="reason"
              onChange={formik.handleChange}
              value={formik.values.reason}
              isInvalid={!!formik.errors.reason}
            />
            <Form.Control.Feedback type="invalid">{formik.errors.reason}</Form.Control.Feedback>
          </div>
        </div>

        <div className="text-center">
          <button disabled={formik.isSubmitting} type="submit" className="btn me-1 btn-theme mb-1">
            <i className="fa fa-save fa-fw me-1"></i> {t('Save')}
          </button>
          <button type="button" className=" btn me-1 btn-default mb-1">
            <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
          </button>
        </div>
      </Form>
    </>
  );
};

export default AddAttendanceAdjustment;
